import Button from '@mui/material/Button'
import { PPDialog } from 'components/PPDialog'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router'
import styles from './ConnectedProfilesWarningPopup.pcss'

export function ConnectedProfilesWarningPopup(props: { open: boolean }) {
  const navigate = useNavigate()

  const goToSettings = () => {
    navigate('/settings/networks')
  }

  return (
    <PPDialog
      open={props.open}
      dismissible={false}
      size="sm"
      title={<FormattedMessage id="composer.profiles-popup.title" />}
      footer={
        <div className={styles.actions}>
          <Button color="primary" variant="contained" onClick={goToSettings}>
            <FormattedMessage id="composer.profiles-popup.action" />
          </Button>
        </div>
      }
    >
      <div className={styles.container}>
        <img className={styles.img} src="/static/img/misc/choose-profile.png" />
        <h2 className={styles.message}>
          <FormattedMessage id="composer.profiles-popup.message" />
        </h2>
      </div>
    </PPDialog>
  )
}
